const en = {
  nav: {
    about: "About",
    services: "Services",
    partners: "Partners",
    contact: "Contact",
    contactBtn: "Contact Us",
  },
  hero: {
    tagline: "JAPAN MARKET ENTRY SPECIALIST",
    title1: "Opening the Door",
    title2: "to Japan's Market.",
    subtitle: "日本市場への扉を、共に開く。",
    description: "Maximizing the potential of overseas brands — Japan's premier general agency partner.",
    descriptionEn: "海外ブランドの可能性を最大化する、日本唯一の総代理店パートナー。",
    cta: "Contact Us",
    ctaEn: "お問い合わせはこちら",
    scroll: "Scroll",
  },
  about: {
    label: "WHO WE ARE",
    labelJa: "私たちについて",
    title: "Our Mission",
    titleEn: "代表メッセージ",
    quote: "Opening the door to Japan's market, together.",
    p1: "We are a team of specialists bridging outstanding overseas brands with the Japanese market. Not a simple import agency, but a strategic partner dedicated to protecting brand value while establishing a lasting presence in Japan.",
    p2: "The challenges overseas manufacturers face in Japan — language barriers, complex regulations, building distribution networks — we handle all of it. We are fully committed to making your brand shine in Japan.",
    p3: "We are not a large corporation — and that is our strength. We engage with each client individually, offering speed and flexibility that big agencies cannot. Leveraging the agility of a small business, we provide hands-on, practical support for overseas manufacturers entering the Japanese market.",
    name: "Taro Yamada",
    title2: "Representative Director & CEO",
    more: "Learn More About Us",
    moreEn: "会社概要を見る",
    stat1: "20+",
    stat1Label: "Countries",
    stat2: "100+",
    stat2Label: "Partners",
    stat3: "15 Yrs",
    stat3Label: "Experience",
    stat4: "98%",
    stat4Label: "Retention",
  },
  services: {
    label: "OUR SERVICES",
    labelJa: "サービス内容",
    title: "End-to-end support for",
    title2: "your Japan market entry.",
    titleEn: "日本市場進出の全工程を、ワンストップで。",
    s1Title: "Crowdfunding Business",
    s1TitleEn: "クラウドファンディング事業",
    s2Title: "E-Commerce Business",
    s2TitleEn: "EC事業",
    s3Title: "SNS Marketing & Advertising",
    s3TitleEn: "SNSマーケティング・広告運用",
    s4Title: "Regulatory & Compliance",
    s4TitleEn: "法規制・認証サポート",
    s5Title: "Customer Support",
    s5TitleEn: "顧客サポート",
    viewAll: "View All Services",
    viewAllEn: "サービス詳細を見る",
    backToHome: "Back to Home",
    pageTitle: "Our Services",
    pageTitle2: "in Detail",
    pageDescription: "Total support from strategy to execution for overseas brands entering the Japanese market. With 20+ years of experience and expertise, we guide your business to success.",
    detail: {
      s1: {
        title: "Crowdfunding Business",
        titleEn: "クラウドファンディング事業",
        desc: "We leverage Japan's leading crowdfunding platforms such as Makuake and Campfire to successfully launch overseas products in the Japanese market. We provide end-to-end support from project design to operations and PR.",
        item1: "Project strategy and design for Makuake, Campfire, and other platforms",
        item2: "Japanese copywriting and visual content production",
        item3: "SNS and PR management during the crowdfunding campaign period",
        item4: "Backer communication, reward fulfillment, and after-support management",
      },
      s2: {
        title: "E-Commerce Business",
        titleEn: "EC事業",
        desc: "We provide comprehensive support for overseas brands' e-commerce operations, from store setup to ongoing management on Japan's major EC platforms including Amazon, Rakuten, and Yahoo! Shopping.",
        item1: "Store setup and launch on Amazon, Rakuten, and Yahoo! Shopping",
        item2: "Product page optimization (SEO, images, copywriting)",
        item3: "Inventory management, logistics, and efficient operations using FBA",
        item4: "Advertising management (sponsored ads, coupons, and sales strategies)",
      },
      s3: {
        title: "SNS Marketing & Advertising",
        titleEn: "SNSマーケティング・広告運用",
        desc: "We leverage the unique characteristics of each SNS platform — Instagram, TikTok, X (formerly Twitter), and YouTube — to implement strategic marketing and advertising that boosts brand awareness and drives purchases.",
        item1: "Platform-optimized content creation and posting management",
        item2: "Influencer marketing and tie-up campaign planning",
        item3: "Meta Ads, Google Ads, and TikTok Ads management and optimization",
        item4: "Data-driven PDCA cycles and performance measurement reports",
      },
      s4: {
        title: "Regulatory & Compliance",
        titleEn: "法規制・認証サポート",
        desc: "Our specialist team provides full support for Japan-specific complex regulations and certifications. Minimize risks and achieve smooth market entry.",
        item1: "Compliance with Pharmaceutical Affairs Act, Food Sanitation Act, Radio Law, etc.",
        item2: "Support for obtaining JIS standards, SG mark, and various certifications",
        item3: "Import procedures and customs support",
        item4: "Product labeling and compliance verification for display obligations",
      },
      s5: {
        title: "Customer Support",
        titleEn: "顧客サポート",
        desc: "Our dedicated support team handles end-user inquiries, complaint resolution, and after-sales service in both Japanese and English. We help strengthen your brand's credibility and improve customer satisfaction.",
        item1: "Multilingual customer support in Japanese and English",
        item2: "Inquiry management system setup and operation",
        item3: "Complaint handling, returns, and exchange process management",
        item4: "Customer satisfaction surveys and feedback analysis",
      },
    },
    ctaTitle: "Start with a Free Consultation",
    ctaDescription: "Our specialist consultants will propose the optimal Japan market entry strategy for your brand, completely free of charge.",
    ctaButton: "Request Free Consultation",
  },
  achievements: {
    label: "ACHIEVEMENTS",
    labelJa: "事業実績",
    title: "Business Achievements",
    titleEn: "事業実績",
    ec: {
      title: "Domestic E-commerce Business",
      titleEn: "国内EC事業",
      description: "We deliver quality products to Japanese consumers through our own e-commerce site and major EC platforms. Annual sales continue to grow steadily, establishing a solid business foundation.",
    },
    web: {
      title: "Website Development & Operations",
      titleEn: "WEBサイト構築・運用",
      description: "We provide one-stop planning, design, development, and operation of high-quality websites for businesses. We enhance our clients' digital presence with the latest technology and design, including responsive design, SEO optimization, and accessibility compliance.",
    },
  },
  partners: {
    label: "TRUSTED BY",
    labelJa: "取引実績",
    title: "Trusted by 100+ companies",
    title2: "across 20+ countries.",
    titleEn: "世界20カ国、100社以上のパートナー企業",
    note: "* Showing a selection of our partners",
    regions: {
      northAmerica: "North America",
      europe: "Europe",
      asia: "Asia",
      oceania: "Oceania",
      middleEast: "Middle East",
    },
  },
  contact: {
    label: "CONTACT US",
    labelJa: "お問い合わせ",
    title: "Contact Form",
    titleEn: "海外メーカー様専用窓口",
    englishAvailable: "英語対応可 / English Available",
    companyName: "Company Name / 会社名",
    yourName: "Your Name / お名前",
    email: "Email / メールアドレス",
    phone: "Phone / 電話番号",
    country: "Country / Region",
    message: "Message / お問い合わせ内容",
    messagePlaceholder: "Please describe your inquiry.\nご相談内容をご記入ください。",
    submit: "Submit / 送信する",
    submitting: "Sending...",
    successTitle: "Message Sent / 送信完了",
    successMsg: "Thank you for your inquiry. Our team will contact you within 2 business days.\nお問い合わせありがとうございます。担当者より2営業日以内にご連絡いたします。",
    directContact: "Direct Contact",
    directContactEn: "直接のご連絡はこちら",
    hours: "Weekdays 9:00 - 18:00 (JST)",
    address: "GlobalBusiness Tower 15F\n1-1-1 Chiyoda, Chiyoda-ku\nTokyo 100-0001, Japan",
    required: "Required",
    selectCountry: "Select Country / Region",
    charLimit: "Max 500 characters",
  },
  process: {
    label: "PROCESS / Flow of Business",
    title: "How We Work",
    subtitle: "From your first inquiry to sales launch, we support you with speed and care.",
    timelineLabel: "TIMELINE",
    timelineTitle: "Standard Steps",
    faqLabel: "FAQ",
    faqTitle: "Frequently Asked Questions",
    ctaTitle: "Feel Free to Consult Us",
    ctaSubtitle: "Please feel free to contact us with any questions about products or business terms.",
    ctaButton: "Contact Us",
    navLink: "How We Work",
    steps: {
      s1Title: "Inquiry",
      s1TitleEn: "お問い合わせ",
      s1Desc: "Please feel free to reach out. Tell us about your product and sales goals.",
      s2Title: "Analysis & Proposal",
      s2TitleEn: "市場分析・ご提案",
      s2Desc: "We analyze your product's potential in the Japanese market and propose the optimal sales strategy, including competitive research and pricing analysis.",
      s3Title: "Contract & Launch",
      s3TitleEn: "契約・販売開始",
      s3Desc: "After signing the contract, we immediately begin sales preparation — launching on crowdfunding platforms and EC marketplaces with speed.",
      s4Title: "Operation & Support",
      s4TitleEn: "運営・サポート",
      s4Desc: "We provide ongoing support after launch — inventory management, customer support, and marketing execution, all handled end-to-end.",
    },
    timeline: {
      t1: "Inquiry & Initial Meeting",
      t2: "Market Analysis & Strategy Planning",
      t3: "Proposal & Contract Signing",
      t4: "Sales Preparation (Page Creation & Inventory)",
      t5: "Sales Launch & Ongoing Support",
    },
    faq: {
      q1: "How long is the contract period?",
      a1: "We offer flexible arrangements based on the scale and content of your project. Short-term contracts for crowdfunding only are also available.",
      q2: "What types of products do you handle?",
      a2: "We handle a wide range of products including electronics, gadgets, lifestyle goods, and apparel. Please feel free to consult us first.",
      q3: "How is inventory managed?",
      a3: "Inventory is stored and managed in our Japanese warehouse, with shipping handled per order. Inventory status can be checked in real time.",
      q4: "How long does it take to start selling?",
      a4: "Sales can typically begin approximately 2 months after contract signing. For crowdfunding, the preparation period may be shorter.",
    },
  },
  strengths: {
    s1: "Annual sales track record of over 30 million yen",
    s2: "3+ years of domestic e-commerce business experience",
    s3: "EC sales experience on Amazon, Rakuten, Yahoo!, and more",
    s4: "Speedy decision-making that large corporations cannot match",
    s5: "Extensive website development and advertising revenue track record",
  },
  footer: {
    description: "Japan's premier general agency partner maximizing the potential of overseas brands. With 20+ years of experience and 100+ partner companies, we bring your brand to Japan.",
    quickLinks: "QUICK LINKS",
    office: "OFFICE",
    legal: "LEGAL",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    tokushoho: "Specified Commercial Transactions Act",
    copyright: "© 2026 SHOP-MK. All Rights Reserved.",
  },
  legal: {
    backHome: "Back to Home",
    lastUpdated: "Last Updated",
  },
  aboutPage: {
    title: "About Us",
    heroSub: "Your strategic partner bridging overseas brands with the Japanese market.",
    missionLabel: "OUR MISSION",
    missionTitle: "Bringing Global Innovation to Japan.",
    missionText1: '"We want to grow. But we don\'t have the bandwidth to expand into new markets."',
    missionText2: "We bring the Japanese market to your business.",
    missionText3: "We are your brand's exclusive distributor in Japan — and your partner. Sales, marketing, logistics, customer support — leave it all to us.",
    missionText4: "First, we test the market through crowdfunding. Once traction is proven, we scale to major e-commerce platforms.",
    missionText5: "You just focus on your product. Japan becomes a new market for your business.",
    missionCta: "Let's build the next stage of your brand, together.",
    bridgeTitle: "Bridging the World and Japan",
    bridgeText1: "We are a comprehensive trading company that provides total support for overseas manufacturers entering the Japanese market through brand agency, e-commerce operations, and advertising management.",
    bridgeText2: "Our company name 'GlobalBridge' embodies our aspiration to grow together with partners around the world.",
    bridgeText3: "Leveraging our experience and expertise gained from importing and selling American products, we provide comprehensive support for overseas manufacturers entering the Japanese market.",
    strengthsLabel: "OUR STRENGTHS",
    strengthsTitle: "Our Strengths",
    strengthSubtitle: "Proven Track Record",
    businessLabel: "OUR BUSINESS",
    businessTitle: "Three Business Pillars",
    companyInfoTitle: "Business Overview",
    info: {
      companyName: "Business Name",
      companyNameValue: "SHOP-MK",
      established: "Established",
      establishedValue: "January 2025",
      representative: "Representative",
      representativeValue: "Masahiro Kisa",
      repProfile: "Representative Profile",
      repText1: "After graduating from university, worked as a systems engineer at a domestic company for 14 years. Gained development and infrastructure experience, serving as project manager on 20+ projects.",
      repText2: "As a side business, successfully monetized a blog site for 3 years, as well as freelance writing and video editing.",
      repText3: "Later ventured into Amazon product sales, achieving consistent results mainly in used goods sales, and became independent. Achieved annual sales of approximately 30 million yen as an individual.",
      repText4: "Currently advancing negotiations with manufacturers from various countries as a general agent for overseas manufacturers.",
      revenue: "Annual Revenue",
      revenueValue: "Approx. 30 million yen (estimated)",
    },
    ctaTitle: "Feel Free to Contact Us",
    ctaText: "Please feel free to contact us with any questions about partnership or products.",
    ctaButton: "Contact Us",
  },
};

export default en;
